import { SocialPlatform, type AppConfig } from "@iyk/vf-app-config"
import { Duration } from "effect"

export const appConfig: AppConfig<"jonas-brothers"> = {
  appId: "jonas-brothers",
  cookiePrefix: "ms",
  lang: "EN",
  artist: {
    name: "Jonas Brothers"
  },
  meta: {
    description: "Jonas Brothers"
  },
  emailSender: {
    name: "Jonas Brothers",
    email: "jonasbrothers@iyk.app"
  },
  s3: {
    get assets() {
      const baseUrl = "https://assets.iyk.app"
      return {
        baseUrl,
        vfUrl: `${baseUrl}/vf`,
        appUrl: `${baseUrl}/${appConfig.appId}`
      }
    },
    get files() {
      return {
        exclusives: `${appConfig.appId}/exclusives`,
        fanClips: `${appConfig.appId}/fan-clips`,
        merchSkus: `${appConfig.appId}/merch-skus`,
        playlistCoverImages: `${appConfig.appId}/playlist-cover-images`,
        showImages: `${appConfig.appId}/show-images`,
        showCheckInRequestImages: `${appConfig.appId}/check-in-request-images`
      }
    },
    get music() {
      return {
        trackAudios: `${appConfig.appId}/track-audios`,
        playlistDownloadFiles: `${appConfig.appId}/playlist-download-files`
      }
    }
  },
  merch: {
    initialOwnerId: "00000000-0000-0000-0000-000000000000",
    initialOwnerAddress: "0x660978862ff3be1e00a2c523ec23b609f878fe4c"
  },
  tasks: {
    exclusiveLinkDelay: Duration.hours(1)
  },
  checkIn: {
    hidePrompt: false
  },
  shopUrl: "https://shop.jonasbrothers.com",
  socialLinks: [
    {
      platform: SocialPlatform.Facebook,
      href: "https://www.facebook.com/JonasBrothers/",
      label: "Facebook"
    },
    {
      platform: SocialPlatform.Instagram,
      href: "https://instagram.com/jonasbrothers",
      label: "Instagram"
    },
    {
      platform: SocialPlatform.TikTok,
      href: "https://tiktok.com/@jonasbrothers",
      label: "TikTok"
    },
    {
      platform: SocialPlatform.Youtube,
      href: "https://www.youtube.com/user/JonasBrothersMusic",
      label: "YouTube"
    },
    {
      platform: SocialPlatform.Twitter,
      href: "https://x.com/jonasbrothers",
      label: "Twitter"
    }
  ],
  joinProof: null,
  get assets() {
    return {
      images: {
        avatar: `${appConfig.s3.assets.appUrl}/avatar.webp`,
        og: `${appConfig.s3.assets.appUrl}/og.png`,
        logo: {
          url: `${appConfig.s3.assets.appUrl}/logo.png`,
          width: 115
        },
        background: `${appConfig.s3.assets.appUrl}/background.webp`,
        howToTap: null,
        email: {
          logo: {
            url: `${appConfig.s3.assets.appUrl}/email-logo.png`,
            width: 115
          }
        },
        roulette: {
          images: Array.from({ length: 6 }, (_, i) => `${appConfig.s3.assets.vfUrl}/roulette/${i + 1}.webp`)
        },
        enableLocation: {
          ios: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_1.png`,
            step2: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_2.png`
          },
          android: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_android.png`
          }
        }
      },
      videos: {
        marquee: null,
        howToTap: null
      },
      documents: {
        privacyPolicy: `${appConfig.s3.assets.baseUrl}/iyk-privacy-policy.pdf`,
        termsOfService: `${appConfig.s3.assets.baseUrl}/iyk-terms-of-service.pdf`,
        artistPrivacyPolicy: null,
        artistTermsOfService: null,
        sweepstakeRules: null
      }
    }
  }
}
